// tslint:disable: max-line-length
import { Component, OnInit, Inject, } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfigToken, DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, DwOrmDataServiceToken, DwOrmDataService, DwQueryHelper, DwSecuritySSOService, DwSecurityRepositoryServiceToken, DwSecurityRepositoryService, DwSecurityUserService, DwQueryFilter, DwOperator, DwFilterType } from '@devwareapps/devware-cap';
import { AppMetaDataService, AppMetaDataLookups } from 'src/app/meta-data/app-meta-data.service';


@DwComponent({
  name: 'NumbersTeam',
  parentItemName: 'UserTeamLookup',
  componentType: DwComponentType.formSection,
})

@Component({
  selector: 'app-numbers-team-control',
  template: ''
})
export class NumbersTeam extends DwSectionBaseComponent<DwComponentSectionPreference>
  implements OnInit {


  wAppsApiUrl: string;
  selectedId: number;
  LookupId = AppMetaDataLookups.ETHOSUSERWachterEmployeesActiveEmployees;
  bearerToken: string;

  // fileId: number;
  constructor(dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  ngOnInit() {

    //if (this.formGroup.get("TeamId") === null) { this.formGroup.addControl("TeamId", new FormControl())} ;
    super.ngOnInit();
    this.LookupId = AppMetaDataLookups.EthosWachterTeamAllItems


        this.formGroup.get("Ethos_UserId").valueChanges.subscribe(x => {
          if (x != null){
          this.getEthosTeam(x).subscribe(y => {
            let z : any = y[0];
            this.formGroup.get("TeamId").setValue(z.WachterTeamId);
            })
          }
          else {
            this.formGroup.get("TeamId").setValue(null);
          }
          })
  }

getEthosTeam(ethosUserId: number) {
  if (typeof ethosUserId === 'string') {
    ethosUserId = parseInt(ethosUserId, 10);
  }
  const md = new AppMetaDataService();
    const filter: DwQueryFilter = new DwQueryFilter();
    filter.Attr = md.RoEthosUser.UserId
    filter.Value = ethosUserId.toString();
    filter.Op = DwOperator.And;
    filter.Type = DwFilterType.Equal;
    const query = md.RoEthosUser.CreateQuery().AddFilterAnd(filter);


    return this.dataService.executeQuery(query);
}

}
